const productData = [
    {
    "id": 1,
    "name": "ACCURO™",
    "category": "Patient Monitoring Systems",
    "description": "Versatile Bedside Pulse Oximeter.",
    "image": "/images/ACCURO™  Versatile Bedside Pulse Oximeter.svg",
    "pdf": "/pdfs/Accuro Verastile BEdside Pulse Oximeter.pdf",
  },
  {
    "id": 2,
    "name": "TOITU MT-610",
    "category": "Patient Monitoring Systems",
    "isTopProduct": true,
    "description": "Fetal Monitor / Actocardiograph",
    "image": "/images/Actocardiograph  MT-610.svg",
    "pdf": "/pdfs/Actocaradigraph MT - 610.pdf",
  },
  {
    "id": 3,
    "name": "DigiDop DD-300",
    "category": "Patient Monitoring Systems",
    "description": "Vascular Doppler",
    "image": "/images/Vascular _ Non-Display Doppler System.svg",
    "pdf": "/pdfs/Digidop classic DD-300.pdf",
  },
  {
    "id": 4,
    "name": "M40",
    "category": "Patient Monitoring Systems",
    "description": "Patient Monitor",
    "image": "/images/M40 patient Monitor for your Clinical Demand.svg",
    "pdf": "/pdfs/M40 patient Monitor for your Clinical Demand.pdf",
  },
  {
    "id": 5,
    "name": "D100",
    "category": ["Patient Monitoring Systems", "Emergency & Cardiac Care"],
    // "category": "Emergency & Cardiac Care",
    "isTopProduct": true,
    "description": "Monitor / Defibrillator",
    "image": "/images/DEFIBRILLATOR DATA SHEET.svg",
    "pdf": "/pdfs/D100 Monitor defibrillator.pdf",
  },
  {
    "id": 6,
    "name": "HeartOn AED (A16)",
    "category": "Emergency & Cardiac Care",
    "description": "Automated External Defibrillator",
    "image": "/images/A 16 HerartOn AED.svg",
    "pdf": "/pdfs/A 16 HerartOn AED.pdf",
  },
  {
    "id": 7,
    "name": "MDB-900",
    "category": "Hospital Furniture",
    "isTopProduct": true,
    "description": "LDR Bed",
    "image": "/images/MDB-900  LDR Bed.svg",
    "pdf": "/pdfs/MDB -900 LDR Bed.pdf",
  },
  {
    "id": 8,
    "name": "MEB-903",
    "category": "Hospital Furniture",
    "description": "Electric Hospital Bed (3 Function)",
    "image": "/images/MEB -903 Electric Hospital bed.svg",
    "pdf": "/pdfs/MEB -903 Electric Hospital bed.pdf",
  },
  {
    "id": 9,
    "name": "MEB-904",
    "category": "Hospital Furniture",
    "description": "Electric ICU/CCU Bed (5 Function)",
    "image": "/images/MEB - 904 Electric ICU CCU Bed.svg",
    "pdf": "/pdfs/MEB - 904 Electric ICU CCU Bed.pdf",
  },
  {
    "id": 10,
    "name": "MET-6600 Eco I / II",
    "category": "Hospital Furniture",
    "description": "Transport / Trauma Stretcher",
    "image": "/images/MET - 6600e Transport trauma stretcher and Met - 6600.svg",
    "pdf": "/pdfs/MET - 6600e Transport trauma stretcher and Met - 6600.pdf",
  },
  {
    "id": 11,
    "name": "MBC-101",
    "category": "Hospital Furniture",
    "description": "ABS Bedside Locker",
    "isTopProduct": true,
    "image": "/images/MBC-101 ABS Bedside Locker and MWA - 300 Recline Chair.svg",
    "pdf": "/pdfs/MBC-101 ABS Bedside Locker and MWA - 300 Recline Chair.pdf",
  },
  {
    "id": 12,
    "name": "MWA-300",
    "category": "Hospital Furniture",
    "description": "Recline Chair",
    "image": "/images/MWA - 300 Recline Chair.svg",
    "pdf": "/pdfs/MBC-101 ABS Bedside Locker and MWA - 300 Recline Chair.pdf",
  },
  {
    "id": 13,
    "name": "MWA-200A",
    "category": "Hospital Furniture",
    "description": "Overbed Table.",
    "image": "/images/MWA - 200A Overbed Table.svg",
    "pdf": "/pdfs/MWA - 200A Overbed Table.pdf",
  },
]

export default productData;